import FileColumnConfig, { COLUMN_TYPE_NUMERIC, COLUMN_TYPE_ALPHA } from "../FileColumnConfig"
import { TYPE as AGENT_TYPE } from '../dto/Agent'
import { TYPE as MORTGAGE_DEAL_TYPE } from '../dto/MortgageDeal'

export const TYPE = {
  TRANSFER_MORTGAGE_DEAL_AGENT: 'transfer_mortgage_deal_agent',
  TRANSFER_MORTGAGE_DEAL_AGENT_PROFILE: 'transfer_mortgage_deal_agent_profile',
}

export const URL = {
  [TYPE.TRANSFER_MORTGAGE_DEAL_AGENT]: 'transfer-mortgage-deal-agent',
  [TYPE.TRANSFER_MORTGAGE_DEAL_AGENT_PROFILE]: 'transfer-mortgage-deal-agent-profile',
}

export const DESCRIPTION = {
  [TYPE.TRANSFER_MORTGAGE_DEAL_AGENT]: 'Transfer all mortgage deals from one agent to another.',
  [TYPE.TRANSFER_MORTGAGE_DEAL_AGENT_PROFILE]: 'Transfer one or more mortgage deals from an agent\'s profile to another profile.',
}

// Columns needed to transfer a Mortgage Deal from one agent to another via CSV file.
export const TRANSFER_MORTGAGE_DEAL_AGENT_COLUMN_CONFIG = [
  {
    alias: 'From Agent',
    columns: [
      (new FileColumnConfig('agent_id', 'from agent id', COLUMN_TYPE_NUMERIC)).requires(null).useValidRules(AGENT_TYPE.AGENT),
    ],
  },
  {
    alias: 'To Agent',
    columns: [
      (new FileColumnConfig('agent_id', 'to agent id', COLUMN_TYPE_NUMERIC)).requires(null).useValidRules(AGENT_TYPE.AGENT),
    ],
  },
]

// Columns needed to transfer a Mortgage Deal from one agent's profile to another via CSV file.
export const TRANSFER_MORTGAGE_DEAL_AGENT_PROFILE_COLUMN_CONFIG = [
  {
    alias: 'Mortgage Deal ID',
    columns: [
      (new FileColumnConfig('mortgage_deal_id', 'mortgage deal id', COLUMN_TYPE_NUMERIC)).requires(null).useValidRules(MORTGAGE_DEAL_TYPE.MORTGAGE_DEAL),
    ]
  },
  {
    alias: 'To Agent Profile',
    columns: [
      (new FileColumnConfig('profile_id', 'to agent profile', COLUMN_TYPE_ALPHA)).requires(null).useValidRules(AGENT_TYPE.AGENT_PROFILE),
    ],
  },
]